import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { LeaveRequest, LeaveRequestPreview, LeaveRequestPreviewParams } from '../models'

export class LeaveRequestService extends KsService {
  protected static mainUrl = '/leave-requests'

  /**
   * Approuve une demande en attente (T55 lot 3) : responsable d'une équipe du demandeur ou RH, jamais sa propre
   * demande. L'API enregistre qui a statué et quand.
   */
  static async approve(id: number, comment?: string): Promise<LeaveRequest> {
    return useApiClient().postRaw<{ comment?: string }, LeaveRequest>(`${this.mainUrl}/${id}/approve`, { comment })
  }

  /** Refuse une demande en attente ; mêmes règles que l'approbation. Le motif est obligatoire (l'API refuse sinon). */
  static async reject(id: number, comment: string): Promise<LeaveRequest> {
    return useApiClient().postRaw<{ comment?: string }, LeaveRequest>(`${this.mainUrl}/${id}/reject`, { comment })
  }

  /**
   * Annule une demande en attente ou approuvée (motif facultatif) : statut « Annulé », jours rendus au solde, salarié
   * notifié, historique conservé. L'API vérifie les droits (salarié : avant le début du congé ; sinon qui peut valider).
   */
  static async cancel(id: number, comment?: string): Promise<LeaveRequest> {
    return useApiClient().postRaw<{ comment?: string }, LeaveRequest>(`${this.mainUrl}/${id}/cancel`, { comment })
  }

  /**
   * Aperçu d'une demande avant l'enregistrement : jours ouvrés, solde disponible avant et après, imputation par
   * période. Lève une erreur (message de l'API) si les dates ou le type sont invalides.
   */
  static async preview(params: LeaveRequestPreviewParams): Promise<LeaveRequestPreview> {
    const query = new URLSearchParams({
      leaveTypeId: String(params.leaveTypeId),
      start: params.start,
      end: params.end,
      startHalfDay: String(!!params.startHalfDay),
      endHalfDay: String(!!params.endHalfDay)
    })
    if (params.employeeId) query.set('employeeId', String(params.employeeId))
    if (params.requestId) query.set('requestId', String(params.requestId))
    return useApiClient().get<LeaveRequestPreview>(`${this.mainUrl}/preview?${query.toString()}`)
  }
}
